import React from "react";
import { Platform, StyleSheet, Text, View } from "react-native";
import { useRouter } from "expo-router";
import {
  Channel as ChannelType,
  type Message as MessageType,
} from "stream-chat";

import { useMessageContext } from "../../context/messaging/StreamContext";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import { useHeaderContext } from "@/context/header/useHeaderContext";

// Define types for placeholders
interface PlaceholderChannelProps {
  children: React.ReactNode;
  channel?: ChannelType;
  additionalKeyboardAvoidingViewProps?: object;
}

interface PlaceholderMessageListProps {
  onThreadSelect?: (message: MessageType) => void;
}

interface PlaceholderMessageInputProps {
  additionalTextInputProps?: object;
}

// Create placeholders for web
const PlaceholderChannel: React.FC<PlaceholderChannelProps> = ({
  children,
}) => <>{children}</>;
const PlaceholderMessageList: React.FC<PlaceholderMessageListProps> = () =>
  null;
const PlaceholderMessageInput: React.FC<PlaceholderMessageInputProps> = () =>
  null;

let ChannelComponent: React.FC<PlaceholderChannelProps> = PlaceholderChannel;
let MessageListComponent: React.FC<PlaceholderMessageListProps> =
  PlaceholderMessageList;
let MessageInputComponent: React.FC<PlaceholderMessageInputProps> =
  PlaceholderMessageInput;

if (Platform.OS !== "web") {
  const { Channel, MessageList, MessageInput } = require("stream-chat-expo"); // eslint-disable-line @typescript-eslint/no-var-requires
  ChannelComponent = Channel;
  MessageListComponent = MessageList;
  MessageInputComponent = MessageInput;
}

function ChannelScreen(): React.JSX.Element {
  const router = useRouter();
  const { channel, setThread } = useMessageContext();
  const { isUserBlocked } = useHeaderContext();

  if (channel !== undefined && channel !== null) {
    return (
      <ScreenLayout isLoading={false}>
        <ChannelComponent
          channel={channel}
          additionalKeyboardAvoidingViewProps={{
            behavior: Platform.OS === "ios" ? "padding" : undefined,
            keyboardVerticalOffset: Platform.OS === "ios" ? 115 : 0, // not sure why the offset is 110
          }}
        >
          <MessageListComponent
            onThreadSelect={(message) => {
              if (message !== null) {
                if (setThread !== undefined && setThread !== null) {
                  setThread(message);
                  router.push("/(main)/messaging/thread");
                }
              }
            }}
          />
          {!isUserBlocked ? (
            <MessageInputComponent
              additionalTextInputProps={{ autoFocus: false, editable: true }}
            />
          ) : (
            <View style={styles.blockedContainer}>
              <Text style={styles.blockedText}>
                Messaging is disabled because either you have blocked this user
                or they have blocked you.
              </Text>
            </View>
          )}
        </ChannelComponent>
      </ScreenLayout>
    );
  }
  return <></>;
}

const styles = StyleSheet.create({
  blockedContainer: {
    padding: 10,
    backgroundColor: "#ffcccc",
    alignItems: "center",
  },
  blockedText: {
    color: "#cc0000",
    fontSize: 16,
  },
});

export default ChannelScreen;
